/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import SqlImportModel from 'cio/models/sql-import';
import { FlyActionDropdownItem } from '@customerio/fly-components/addon/components/fly-action-dropdown';
import { tracked } from '@glimmer/tracking';

interface SqlImportsListItemArgs {
  model: SqlImportModel;
}

export default class SqlImportsListItem extends Component<SqlImportsListItemArgs> {
  @tracked confirmingStatusChange = false;
  @tracked confirmingDelete = false;

  get options(): FlyActionDropdownItem[] {
    let options = [];

    if (!this.args.model.isDraft) {
      if (!this.args.model.active) {
        options.push({
          label: 'Activate sync',
          action: this.toggleConfirmStatusChange,
          disabled: false,
        });
      } else {
        options.push({
          label: 'Pause sync',
          action: this.toggleConfirmStatusChange,
          disabled: false,
        });
      }
    }

    options.push({
      label: 'Delete sync',
      classNames: 'text-error',
      action: this.toggleConfirmDelete,
      disabled: false,
    });

    return options;
  }

  @action
  toggleConfirmStatusChange() {
    this.confirmingStatusChange = !this.confirmingStatusChange;
  }

  @action
  toggleConfirmDelete() {
    this.confirmingDelete = !this.confirmingDelete;
  }
}
